import useManagement from 'client/hooks/useManagement'
import pageToolboxMap from 'client/pages/pageToolboxMap'
import { usePage } from 'client/store'
import { isUserAdmin } from 'client/store/management/managementSelectors'
import { isWebsitePageType } from 'client/store/page/pageSelectors'
import { pageTypes } from 'common/constants/pageTypes'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { LibraryElementEnum } from 'src/shared/enums/LibraryElementEnum'
import {
  libraryGroups,
  libraryGroupsTitles,
  libraryItems,
} from '../library/library-items'
import { LibraryElement } from './library-element'

interface ElementsProps {
  pageType: PageTypeEnum
}

export const Elements = ({ pageType }: ElementsProps) => {
  const isAdmin = useManagement(isUserAdmin)
  const { t } = useTranslation()

  const isWebsitePage = usePage(isWebsitePageType)

  const libraryElements = { ...pageToolboxMap[pageType] }

  const shouldShowLanguageSwitcher = !isWebsitePage
  const shouldShowPriceElement =
    pageType === pageTypes.salesPage || pageType === PageTypeEnum.WebsitePricing

  return (
    <React.Fragment>
      {Object.keys(libraryElements).map(groupItemsKey => (
        <div key={groupItemsKey} className="mb-7.5">
          <div className="mb-2.5 text-heading-5 text-textPrimary">
            <Trans parent={'span'}>{libraryGroupsTitles[groupItemsKey]}</Trans>
          </div>
          <section className="grid grid-cols-3 gap-1.5 after:grow-0 after:content-['']">
            {libraryElements[groupItemsKey].map(libraryElementType => {
              return (
                <LibraryElement
                  key={libraryElementType}
                  type={libraryElementType}
                  className={libraryItems[libraryElementType]?.className}
                  iconRenderer={libraryItems[libraryElementType]?.iconRenderer}
                  title={t(libraryItems[libraryElementType]?.title)}
                />
              )
            })}
          </section>
        </div>
      ))}
      {isAdmin && (shouldShowLanguageSwitcher || shouldShowPriceElement) && (
        <div key={libraryGroups.sio} className="mb-7">
          <div className="mb-2.5 text-heading-5 text-textPrimary">
            <Trans parent={'span'}>
              {libraryGroupsTitles[libraryGroups.sio]}
            </Trans>
          </div>
          <section className="flex shrink basis-[92px] flex-wrap justify-between gap-1.5 after:grow-0 after:content-['']">
            {shouldShowLanguageSwitcher && (
              <LibraryElement
                key={LibraryElementEnum.LibraryLanguageSwitcher}
                type={LibraryElementEnum.LibraryLanguageSwitcher}
                className={
                  libraryItems[LibraryElementEnum.LibraryLanguageSwitcher]
                    .className
                }
                title={t(
                  libraryItems[LibraryElementEnum.LibraryLanguageSwitcher]
                    .title,
                )}
              />
            )}
            {shouldShowPriceElement && (
              <LibraryElement
                key={LibraryElementEnum.LibraryPriceElement}
                type={LibraryElementEnum.LibraryPriceElement}
                className={
                  libraryItems[LibraryElementEnum.LibraryPriceElement].className
                }
                title={t(
                  libraryItems[LibraryElementEnum.LibraryPriceElement].title,
                )}
              />
            )}
          </section>
        </div>
      )}
    </React.Fragment>
  )
}
